import { render, staticRenderFns } from "./CloudinarySEOItem.vue?vue&type=template&id=c94e5e94&scoped=true"
import script from "./CloudinarySEOItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CloudinarySEOItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CloudinarySEOItem.vue?vue&type=style&index=0&id=c94e5e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94e5e94",
  null
  
)

export default component.exports